import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isFedRamp } from '@atlaskit/atlassian-context';
import { fg } from '@atlaskit/platform-feature-flags';
import RovoAgentCardClient from './RovoAgentCardClient';
import TeamCentralCardClient from './TeamCentralCardClient';
import TeamProfileCardClient from './TeamProfileCardClient';
import UserProfileCardClient from './UserProfileCardClient';
var defaultConfig = {
  gatewayGraphqlUrl: '/gateway/api/graphql'
};
var ProfileCardClient = /*#__PURE__*/function () {
  function ProfileCardClient(config, clients) {
    var _config$gatewayGraphq;
    _classCallCheck(this, ProfileCardClient);
    //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
    var withDefaultConfig = _objectSpread(_objectSpread(_objectSpread({}, defaultConfig), config), {
      gatewayGraphqlUrl: (_config$gatewayGraphq = config.gatewayGraphqlUrl) !== null && _config$gatewayGraphq !== void 0 ? _config$gatewayGraphq : defaultConfig.gatewayGraphqlUrl
    });
    this.userClient = (clients === null || clients === void 0 ? void 0 : clients.userClient) || new UserProfileCardClient(withDefaultConfig);
    this.teamClient = (clients === null || clients === void 0 ? void 0 : clients.teamClient) || new TeamProfileCardClient(withDefaultConfig);
    this.rovoAgentClient = (clients === null || clients === void 0 ? void 0 : clients.rovoAgentClient) || new RovoAgentCardClient(withDefaultConfig);
    this.tcClient = maybeCreateTeamCentralClient(config, clients);
  }
  _createClass(ProfileCardClient, [{
    key: "flushCache",
    value: function flushCache() {
      var _this$tcClient, _this$rovoAgentClient;
      this.userClient.flushCache();
      this.teamClient.flushCache();
      (_this$tcClient = this.tcClient) === null || _this$tcClient === void 0 || _this$tcClient.flushCache();
      (_this$rovoAgentClient = this.rovoAgentClient) === null || _this$rovoAgentClient === void 0 || _this$rovoAgentClient.flushCache();
    }
  }, {
    key: "getProfile",
    value: function getProfile(cloudId, userId, analytics) {
      return this.userClient.getProfile(cloudId, userId, analytics);
    }
  }, {
    key: "getTeamProfile",
    value: function getTeamProfile(teamId, orgId, analytics) {
      return this.teamClient.getProfile(teamId, orgId, analytics);
    }
  }, {
    key: "getReportingLines",
    value: function getReportingLines(userId) {
      var _this$tcClient2;
      return ((_this$tcClient2 = this.tcClient) === null || _this$tcClient2 === void 0 ? void 0 : _this$tcClient2.getReportingLines(userId)) || Promise.resolve({
        managers: [],
        reports: []
      });
    }
  }, {
    key: "getTeamCentralBaseUrl",
    value: function getTeamCentralBaseUrl() {
      var _this$tcClient3;
      return (_this$tcClient3 = this.tcClient) === null || _this$tcClient3 === void 0 ? void 0 : _this$tcClient3.options.teamCentralBaseUrl;
    }
  }, {
    key: "shouldShowGiveKudos",
    value: function shouldShowGiveKudos() {
      if (!this.tcClient || !this.getTeamCentralBaseUrl()) {
        return Promise.resolve(false);
      }
      return this.tcClient.checkWorkspaceExists();
    }
  }, {
    key: "getRovoAgentProfile",
    value: function getRovoAgentProfile(id, analytics) {
      var _this$rovoAgentClient2;
      return (_this$rovoAgentClient2 = this.rovoAgentClient) === null || _this$rovoAgentClient2 === void 0 ? void 0 : _this$rovoAgentClient2.getProfile(id, analytics);
    }
  }, {
    key: "deleteAgent",
    value: function deleteAgent(id, analytics) {
      var _this$rovoAgentClient3;
      return (_this$rovoAgentClient3 = this.rovoAgentClient) === null || _this$rovoAgentClient3 === void 0 ? void 0 : _this$rovoAgentClient3.deleteAgent(id, analytics);
    }
  }, {
    key: "setFavouriteAgent",
    value: function setFavouriteAgent(id, isFavourite, analytics) {
      var _this$rovoAgentClient4;
      return (_this$rovoAgentClient4 = this.rovoAgentClient) === null || _this$rovoAgentClient4 === void 0 ? void 0 : _this$rovoAgentClient4.setFavouriteAgent(id, isFavourite, analytics);
    }
  }]);
  return ProfileCardClient;
}();
function maybeCreateTeamCentralClient(config, clients) {
  if (isFedRamp()) {
    return undefined;
  }
  if (clients !== null && clients !== void 0 && clients.teamCentralClient) {
    return clients.teamCentralClient;
  }
  var teamCentralEnabled = fg('enable_ptc_sharded_townsquare_calls') ? config.teamCentralDisabled !== true : config.teamCentralUrl;
  return teamCentralEnabled ? new TeamCentralCardClient(_objectSpread({}, config)) : undefined;
}
export default ProfileCardClient;